module Meevo.Components.Controls.SmartMover {
    export class DiscountFeesCollection extends SmartMoverApiCollection<any> implements IApiCollection<any> {

        get url() {
            return 'DiscountFee';
        }
    }
}
